import request from '@/utils/request'

//列表接口
export function getLogin(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  });
}

//图形验证码
export function getCaptchaCache(params) {
  return request({
    url: '/api/getSmsCaptcha',
    method: 'get',
    params
  });
}
export function getCaptchaCache1(params) {
  return request({
    url: '/api/getCaptchaCache',
    method: 'get',
    params
  });
}

//图形验证码
export function SendSms(data) {
  return request({
    url: '/api/sendSms',
    method: 'post',
    data
  });
}
//观众的个人信息
export function getMe(params) {
  return request({
    url: '/api/me',
    method: 'get',
    params
  });
}
//登出
export function logout(params) {
  return request({
    url: '/api/logout',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js